import { stateProperty, State } from "@dodona/lit-state";

class ExerciseState extends State {
    @stateProperty public id: number;
}

export const exerciseState = new ExerciseState();
